import React, { useEffect, useState } from "react";
import "../../App.css";

interface ForecastModelProps {
  setSelectedModel: (item: string) => void;
}

let floodModel: string = "GloFas"; 

const FloodModel: React.FC<ForecastModelProps> = ({
  setSelectedModel,
}) => {
  const [selectedItem, setSelectedItem] = useState("GloFas");

  const handleItemClick = (item: any) => {
    if (selectedItem === item) {
      setSelectedItem("GloFas");
      setSelectedModel("GloFas");
      floodModel="GloFas";
    } else {
      setSelectedModel(item);
      setSelectedItem(item);
      floodModel=item;
    }
  };

  useEffect(() => {
    setSelectedItem(floodModel);
  }, []);
  
  useEffect(() => {

  }, [floodModel]);
  

  return (
    <
    >
      <div
        className="forecast-model-flood"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gridTemplateRows: "repeat(2, 1fr)",
          gap: "3px",
          backdropFilter: "blur(5.5px)",
          WebkitBackdropFilter: "blur(5.5px)",
        }}
    
      >
        <div
          className={`forecast-model-flood-item ${
            selectedItem === "GloFas" && "selected"
          }`}
          onClick={() => handleItemClick("GloFas")}
                onTouchStart={() => handleItemClick("GloFas")}
        >
          <span>GloFas</span>
          {/* <span style={{ fontSize: "8px", marginLeft: "2px" }}>9km</span> */}
        </div>
        <div
          className={`forecast-model-flood-item ${
            selectedItem === "Anuga" && "selected"
          }`}
          onClick={() => handleItemClick("Anuga")}
          onTouchStart={() => handleItemClick("Anuga")}
        >
          <span>Anuga</span>
          {/* <span style={{ fontSize: "8px", marginLeft: "2px" }}>22km</span> */}
        </div>
        <div
          className={`forecast-model-flood-item ${
            selectedItem === "Hecras" && "selected"
          }`}
          onClick={() => handleItemClick("Hecras")}
          onTouchStart={() => handleItemClick("Hecras")}
        >
          <span>Hecras</span>
          {/* <span style={{ fontSize: "8px", marginLeft: "2px" }}>13km</span> */}
        </div>
        <div
          className={`forecast-model-flood-item ${
            selectedItem === "CMOD" && "selected"
          }`}
          onClick={() => handleItemClick("CMOD")}
          onTouchStart={() => handleItemClick("CMOD")}
        >
          <span>CMOD</span>
          {/* <span style={{ fontSize: "8px", marginLeft: "2px" }}>13km</span> */}
        </div>
      </div>
    
    </>
  );
};

export default FloodModel;
